import { AuthProvider } from "./lib/AuthContext";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import AppRoutes from "./lib/AppRoutes";

const App = () => {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
        retry: false,
      },
    },
  });

  return (
    <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <AppRoutes />
        </AuthProvider>
    </QueryClientProvider>
  );
};

export default App;
